import { isFinite } from 'lodash-es';
import { forwardRef } from 'react';

import { NumberInputProps, NumberInputBase } from './NumberInputBase.js';
import { useControllableState } from '../../core/hooks/useControllableState.js';
import type { FormControlRef } from '../shared-types.js';

/**
 * Number inputs let users enter and edit integers and floating-point numbers.
 * @public
 */
export const NumberInput = /* @__PURE__ */ forwardRef<
  FormControlRef<HTMLDivElement>,
  NumberInputProps
>((props, forwardedRef) => {
  const { defaultValue, value, onChange, ...remainingProps } = props;

  const [internalValue, setInternalValue] = useControllableState({
    defaultValue,
    value,
    onChange,
  });

  const handleChange = (newValue: number | null) => {
    try {
      const newInternalValue = isFinite(newValue) ? newValue : null;
      setInternalValue(newInternalValue);
    } catch {
      //
    }
  };

  return (
    <NumberInputBase
      ref={forwardedRef}
      value={internalValue}
      onChange={handleChange}
      {...remainingProps}
    />
  );
});
(NumberInput as typeof NumberInput & { displayName: string }).displayName =
  'NumberInput';
